import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchTechnology(params) {
  return await request({
    url: ENDPOINT.HOME_TECHNOLOGY,
    method: "get",
    params,
  });
}

export async function fetchTechnologyById(id) {
  return await request({
    url: `${ENDPOINT.HOME_TECHNOLOGY}/${id}`,
    method: "get",
  });
}

export async function createTechnology(data) {
  return await request({
    url: ENDPOINT.HOME_TECHNOLOGY,
    method: "post",
    data,
  });
}

export async function updateTechnology(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_TECHNOLOGY}/${id}`,
    method: "put",
    data,
  });
}

export async function deleteTechnology(id) {
  return await request({
    url: `${ENDPOINT.HOME_TECHNOLOGY}/${id}`,
    method: "delete",
  });
}